<template>
  <RouterView/>
</template>
<script>
// Animation maybe
// <RouterView v-slot="{ Component }">
//   <Transition name="fade">
//     <Component :is="Component" />
//   </Transition>
// </RouterView>

export default {
  created () {
    this.$store.commit('notModal')
    this.$store.dispatch('getData')
  }
}
</script>
<style lang="scss">
@import "./assets/scss/common";
@import "./assets/scss/mixins";

$font-dir: "./assets/fonts/";

//// font-family: 'DIN';
@font-face {
  font-family: "DIN";
  src: url("#{$font-dir}DIN-Light.woff2") format("woff2");
  font-weight: 300;
}

@font-face {
  font-family: "DIN";
  src: url("#{$font-dir}DIN-Regular.woff2") format("woff2");
  font-weight: 400;
}

@font-face {
  font-family: "DIN-Medium";
  src: url("#{$font-dir}DIN-Medium.woff2") format("woff2");
  font-weight: 500;
}

@font-face {
  font-family: "DIN";
  src: url("#{$font-dir}DIN-Bold.woff2") format("woff2");
  font-weight: 700;
}

#eligibility-check {
  margin-bottom: 2rem;

  &.container {
    max-width: 1200px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding: 0;

    @include respond-above(lg) {
      padding: 0 50px;
    }
  }
}
</style>
